import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

export const EVENTQ_BROWSER_TAB_INACTIVE_WIDTH_PX = 180;
export const EVENTQ_BROWSER_TAB_ACTIVE_WIDTH_PX = 320;

@Component({
  selector: 'eventq-browser-tab',
  imports: [MatIcon, MatTooltip],
  templateUrl: './browser-tab.html',
  styleUrl: './browser-tab.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'eventq-browser-tab-host',
    '[attr.data-tab-id]': 'tabId()',
    '[class.eventq-browser-tab-host--active]': 'active()',
    '[class.eventq-browser-tab-host--hovered]': 'hovered() && !active()',
    '[class.eventq-browser-tab-host--popout]': 'popoutMode()',
    '[style.--eventq-browser-tab-default-width.px]': 'inactiveWidthPx',
    '[style.--eventq-browser-tab-min-width.px]': 'inactiveWidthPx',
    '[style.--eventq-browser-tab-active-width.px]': 'activeWidthPx',
    '[style.--eventq-browser-tab-active-min-width.px]': 'activeWidthPx',
    '[style.--eventq-browser-tab-active-max-width.px]': 'activeWidthPx',
  },
})
export class EventqBrowserTab {
  readonly inactiveWidthPx = EVENTQ_BROWSER_TAB_INACTIVE_WIDTH_PX;
  readonly activeWidthPx = EVENTQ_BROWSER_TAB_ACTIVE_WIDTH_PX;
  readonly tabId = input.required<string>();
  readonly label = input.required<string>();
  readonly tags = input<string[]>([]);
  readonly active = input(false);
  readonly expanded = input(false);
  readonly hovered = input(false);
  readonly popoutMode = input(false);
  /** When false, hides the expand / popout control (feature-flagged in the app). */
  readonly expandEnabled = input(true);
  /** When true, shows the close-tab control (events landing only, multi-tab). */
  readonly closeEnabled = input(false);
  /** `HH:MM:SS` processing runtime; omit or empty hides the Runtime pill. */
  readonly runtimeLabel = input<string | null>(null);

  readonly selected = output<void>();
  readonly expand = output<void>();
  readonly closed = output<void>();
  readonly pointerenter = output<void>();
  readonly pointerleave = output<void>();

  readonly tooltipText = computed(() => {
    const tagList = this.tags();
    if (!tagList.length) {
      return this.label();
    }

    return `${this.label()}\n${tagList.join(' · ')}`;
  });

  onSelect(): void {
    if (this.popoutMode()) {
      return;
    }

    this.selected.emit();
  }
}
